import React, {useState} from "react";
import {Card, Grid, Heading, Expander, View, Text, Flex, ExpanderItem} from "@aws-amplify/ui-react";
import {Link} from "react-router-dom";
import styles from './index.module.css';
import {previewCardDescription} from "../../utils";
import injectWindowSize from "../InjectWindowSize";

const ItemsCollection = (
  {
    items = [],
    courseId = null,
    lessonId = null,
    backgroundColor = "detail",
    windowSize = {}
  }
) => {
  const [value, setValue] = useState("items");

  const getBackgroundColor = () => {
    switch (backgroundColor) {
      case "primary":
        return styles.backgroundPrimary;
      case "secondary":
        return styles.backgroundSecondary;
      case "detail":
      default:
        return styles.backgroundDetail;
    }
  }

  const getItemLink = (itemId) => {
    switch (true) {
      case !!courseId && !!lessonId:
        return `/corsi/${courseId}/lezioni/${lessonId}/approfondimenti/${itemId}`;
      case !!courseId && !lessonId:
        return `/corsi/${courseId}/lezioni/${itemId}`;
      case !courseId && !lessonId:
      default:
        return "/";
    }
  }

  const getItemsCollectionTitle = () => {
    switch (true) {
      case !!courseId && !!lessonId:
        return "Approfondimenti";
      case !!courseId && !lessonId:
        if (courseId === 3199) {
          return "Video";
        }
        else if (courseId === 3614) {
          return "Webinar";
        }
        else {
          return "Articoli";
        }
      default:
        return ""
    }
  }

  const getElementsPerRow = () => {
    const {
      breakpointStep = "",
    } = windowSize || {};

    switch (breakpointStep) {
      case "xxl":
      case "xl":
      case "lg":
        return 3;
      case "md":
        return 2;
      case "sm":
      case "xs":
      default:
        return 1;
    }
  }

  const expanderClassNames = [styles.expander, getBackgroundColor()];

  const finalItems = [];
  let finalItemsRow = [];

  items.forEach((item, i) => {
    const augmentedIndex = i + 1
    const elementsPerRow = getElementsPerRow()

    finalItemsRow.push(item);

    if (augmentedIndex % elementsPerRow === 0 || augmentedIndex === items.length) {
      finalItems.push(finalItemsRow);
      finalItemsRow = [];
    }
  })

  return finalItems.length > 0 ?
    (
      <Expander
        isCollapsible
        type="single"
        value={value}
        onValueChange={setValue}
        className={expanderClassNames.join(" ")}
      >
        <ExpanderItem
          title={
            <View className={styles.titleView}>
              <Heading level={4}>
                {getItemsCollectionTitle()}
              </Heading>
            </View>
          }
          value="items"
          className={styles.expanderItem}
        >
          <Flex
            direction="column"
          >
            {
              finalItems.map(itemsRow => (
                <Grid
                  key={JSON.stringify(itemsRow)}
                  templateColumns={{base: `repeat(${itemsRow.length}, 1fr)`}}
                  templateRows={{base: "auto"}}
                  gap="1rem"
                >
                  {
                    itemsRow.map(item => {
                      const {
                        cover = "",
                        title = "",
                        description = "",
                        abstract = null,
                        id = 0
                      } = item;

                      const cardClassNames = [styles.itemCard, getBackgroundColor()];

                      return (
                        <Link
                          key={`card_${id}`}
                          to={getItemLink(id)}
                          onClick={() => setValue(null)}
                        >
                          <Card
                            borderRadius="medium"
                            variation="elevated"
                            className={cardClassNames.join(" ")}
                          >
                            <Flex
                              height="100%"
                              direction="column"
                              justifyContent="space-between"
                            >
                              <Flex
                                textAlign="center"
                                alignItems="center"
                                justifyContent="center"
                                backgroundImage={`linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.5)), url(${cover})`}
                                className={styles.itemTitleWrapper}
                              >
                                <Text className={courseId !== 3201 ? styles.itemTitle : styles.itemTitleKids}>
                                  {title}
                                </Text>
                              </Flex>

                              {
                                ![3199,3614].includes(parseInt(courseId)) &&
                                <Text className={styles.itemDescriptionPreview}>

                                  {previewCardDescription(abstract ?? description)}
                                </Text>
                              }
                            </Flex>
                          </Card>
                        </Link>
                      )
                    })
                  }
                </Grid>
              ))
            }
          </Flex>
        </ExpanderItem>
      </Expander>
    ) :
    null;
}

export default injectWindowSize(ItemsCollection);